<template>

  <!--input type="text" v-mask="'##/##/####'" class="form-input"/-->

    <div class="flex flex-col min-h-screen">

    <div class="flex-none bg-sky-700 text-white">
      <HeaderComponent @clear-all="clearAll" @export-to-pdf="exportToPDF"  />
    </div>

    <div class="flex-none bg-sky-100 text-white">
      <!--HeroComponent /-->
    </div>

    <div class="grow bg-white text-black py-10">

      <!-- DETERMINER LE DERNIER JOUR DE TRAVAIL A INDIQUER SUR L'ATTESTATION DE SALAIRE -->
      <div class="flex justify-center space-x-5">
        <div class="sm:w-11/12 lg:w-3/4">
          <div class="card">

            <h5 class="h5">Etape 4 - Je détermine le dernier jour de travail à indiquer sur l'attestation de salaire</h5>

            <div class="flex flex-row space-x-5 mt-5">
              <label for="risques" class="flex-none form-label mt-3 w-2/5">Situation du salarié - Risque concerné:</label>
              <select id="risques" v-model="selectSituation"
              class="form-select">
                <option value="MM" selected>Maladie - Maternité</option>
                <option value="P1">Paternité - 1ère interruption de travail</option>
                <option value="P2">Paternité - 2nd interruption de travail et suivantes </option>
                <option value="ATMP">Accident du travail / Maladie Professionnelle</option>
                <option value="ATA">Accident de trajet - en allant travailler</option>
                <option value="ATS">Accident de trajet - en sortant du travail</option>
              </select>
            </div>

            <div class="flex flex-row space-x-5 mt-5 items-center">
              <label for="" class="form-label mt-3 w-2/5">{{ dateSituationLabel }}:</label>
              <div class="relative max-w-sm">
                <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                  <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                  </svg>
                </div>
                <input type="text" v-mask="'##/##/####'" v-model="dateSituationSaisie" :class="[ !dateSituationSaisie || !isValidDate(dateSituationSaisie) ? 'form-input-error' : 'form-input-success']" placeholder="jj/mm/aaaa">
              </div>
            </div>

            <div class="flex flex-row space-x-5 mt-5 items-center">
              <label for="dateSituationCalculee" class="form-label w-2/5 mt-3">Dernier jour de travail à renseigner sur l'attestation de salaire:</label>
              <div class="relative max-w-sm">
                <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                  <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                  </svg>
                </div>
                <input v-model="sDateSituationCalculee" disabled class="form-input-disabled">
              </div>
            </div>
            <br>
            <div class="mt-5 text-sm font-medium">
              La période de référence est à déterminer à partir du dernier jour de travail (DJT) et du risque
              concerné.<br>
              Pour un salarié standard en {{ selectSitutationText }}, il convient de déclarer les éléments de salaire se
              rapportant au(x) mois de
              <span class="text-green-600">
                <span v-show="(selectSituation == 'MM' || selectSituation == 'P1' || selectSituation == 'P2') && dateSup">{{
                  dateInfMonth }} à</span>
                {{ dateSupMonth }}
              </span>
              <br>
              <div v-show="(selectSituation == 'MM' || selectSituation == 'P1' || selectSituation == 'P2') && dateSup">
                <br>
                Pour réaliser la simulation des IJ Maladie, poursuivez sur la page
                 <a target="_blank" class="font-medium text-blue-600 dark:text-blue-500 hover:underline" href="https://simulij.assure.ameli.fr/simulij/questionnaire/0">suivante</a>.
              </div>
              <!--{{ dateInf }} -> {{ dateSup }}-->
            </div>

          </div>
        </div>
      </div>

      <div v-show="selectSituation == 'ATMP' || selectSituation == 'ATA' || selectSituation == 'ATS'">

        <!-- INDIQUER LES ELEMENTS DE SALAIRE A DECLARER CORRESPONDANTS AU(X) MOIS DE REFERENCE-->
        <div class="flex justify-center space-x-5 mt-5">
          <div class="sm:w-11/12 lg:w-3/4">
            <div class="card">
              <h5 class="h5">
                Etape 5 (1/3) - Indiquer les élements de salaire à déclarer qui correspondent au(x) mois de référence
              </h5>
              <div class="flex flex-row space-x-5 mt-5">
                <label for="salaireBrut" class="mt-3 form-label w-2/5">Salaire de base brut soumis à cotisations (en €): </label>
                <input type="text" v-model="salaireBrut" class="form-input w-48" :class="[ !salaireBrut || !isValidNumber(salaireBrut) ? 'form-input-error' : 'form-input-success']">
              </div>
              <div class="flex flex-row space-x-5 mt-5">
                <label for="montantCotisations" class="mt-3 form-label w-2/5">Montant des cotisations à déclarer (21% du Brut): </label>
                <input disabled v-model="montantCotisations" class="form-input-disabled w-48">
              </div>
            </div>
          </div>
        </div>
      
        <!-- PRIMES -->
        <div class="flex justify-center space-x-5 mt-5">
          <div class="sm:w-11/12 lg:w-3/4">
          <div class="card">
            <div class="flex flex-row justify-between">
              <h5 class="h5">
              Etape 5 (2/3) - Primes : Annuelles, Semestrielles, Trimestrielles, Mensuelles, exceptionnelles
            </h5>
            <button v-on:click="addPrime" type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Ajouter prime</button>            
            </div>                        
            <!-- Table des primes-->
            <div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-5">
              <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th scope="col" class="px-6 py-3 text-center">
                      Date de versement
                    </th>
                    <th scope="col" class="px-6 py-3 text-center">
                      Du
                    </th>
                    <th scope="col" class="px-6 py-3 text-center">
                      Au
                    </th>
                    <th scope="col" class="px-6 py-3 text-center">
                      Montant brut
                    </th>                                        
                    <th scope="col" class="px-6 py-3 text-center">
                      Cette Prime doit-elle figurer sur l'attestation de salaire ?
                    </th>
                    <th></th>
                    <!--th>Périodicité</th>
                    <th>Se reporte du</th>
                    <th>Se reporte au</th>
                    <th>Montant périodicité</th--> 
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700"
                    v-for="prime in primes" v-bind:key="prime.id">
                    <td class="px-6 py-4">
                      <input type="text" v-mask="'##/##/####'" v-model="prime.dateVersement" placeholder="jj/mm/aaaa"
                        :class="[ !prime.dateVersement || !isValidDate(prime.dateVersement) ? 'form-input-error' : 'form-input-success']">
                    </td>
                    <td class="px-6 py-4">
                      <input type="text" v-mask="'##/##/####'" v-model="prime.du" placeholder="jj/mm/aaaa"
                        :class="[ !prime.du || !isValidDate(prime.du) ? 'form-input-error' : 'form-input-success']">
                    </td>
                    <td class="px-6 py-4">
                      <input type="text" v-mask="'##/##/####'" v-model="prime.au" placeholder="jj/mm/aaaa"
                        :class="[ !prime.au || !isValidDate(prime.au) ? 'form-input-error' : 'form-input-success']">                      
                    </td>
                    <td class="px-6 py-4">                      
                      <input type="text" v-model="prime.montant" 
                      :class="[ !prime.montant || !isValidNumber(prime.montant) ? 'form-input-error' : 'form-input-success']">
                    </td>                    
                    <td class="px-6 py-4 text-center">{{ prime.priseEnCompte==null ? '-' : prime.priseEnCompte ? 'Oui' : 'Non' }}</td>
                    <td class="px-6 py-4">                      
                      <button type="button"
                        class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
                        @click="deletePrime(prime.id)">
                        <svg class="w-6 h-6 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                          height="24" fill="currentColor" viewBox="0 0 24 24">
                          <path fill-rule="evenodd"
                            d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7.707-3.707a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293Z"
                            clip-rule="evenodd" />
                        </svg>
                      </button>
                    </td>                    
                    <!--td class="px-6 py-4">{{ prime.periodicite }}</td>
                    <td class="px-6 py-4">{{ prime.dateReportDebut!=null ? prime.dateReportDebut.toISOString().substr(0, 10) : '' }}</td>
                    <td class="px-6 py-4">{{ prime.dateReportFin!=null ? prime.dateReportFin.toISOString().substr(0, 10) : '' }}</td>                    
                    <td class="px-6 py-4">{{ prime.montantPeriodicite }}</td--> 
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          </div>
        </div>
        
        <!-- RETABLISSEMENT DE SALAIRE-->
        <div class="flex justify-center space-x-5 mt-5">
          <div class="sm:w-11/12 lg:w-3/4">
            <div class="card">
              <h5 class="h5">
                Etape 5 (3/3) - Rétablissement de salaire
              </h5>
              
              <div class="flex items-center">
                  <input v-model="radioRetablissementSalaire" checked id="default-radio-2" type="radio" value="salaireBrutContractuel" name="default-radio" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                  <label for="default-radio-2" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Je connais le montant du salaire brut contractuel</label>
              </div>
              <div class="flex items-center mb-4 mt-5">
                <input v-model="radioRetablissementSalaire" id="default-radio-1" type="radio" value="perteSalaire" name="default-radio" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                <label for="default-radio-1" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Je connais le montant de la perte de salaire</label>
              </div>
              
              <!--div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-5"-->
              <div class="relative overflow-x-auto mt-5">
                <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th scope="col" class="px-6 py-3 text-center">
                      </th>
                      <th scope="col" class="px-6 py-3 text-center">
                        Vérifier le salaire rétabli
                      </th>                    
                      <th scope="col" class="px-6 py-3 text-center">
                        Déclarer le montant des cotisations (21% du Brut)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                      <th class="px-6 py-4">
                        Salaire de base Brut réellement perçu
                      </th>
                      <td class="px-6 py-4 text-center">
                          {{ salaireBrut }}
                      </td>                    
                      <td class="px-6 py-4 text-center">
                      </td>                    
                    </tr>
                    <tr
                      class="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                      <th class="px-6 py-4">
                        Montant de la perte de salaire 
                      </th>
                      <td v-if="radioRetablissementSalaire=='perteSalaire'" class="px-6 py-4 text-center">                        
                          <input type="text" v-model="montantPerteSalaire" :class="[ !montantPerteSalaire || !isValidNumber(montantPerteSalaire) ? 'form-input-error' : 'form-input-success']"/>
                      </td>
                      <td class="px-6 py-4 text-center" v-else>{{ montantPerteSalaire }}</td>
                      <td class="px-6 py-4 text-center">
                          {{ montantCotisationsCalcule }}
                      </td>
                    </tr>
                    <tr
                      class="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">
                      <th class="px-6 py-4">
                        Montant du salaire Brut contractuel (si le salarié a travaillé toute la période)
                      </th>
                      <td v-if="radioRetablissementSalaire=='salaireBrutContractuel'" class="px-6 py-4">                        
                          <input type="text" v-model="montantSalaireBrutContractuel" 
                          :class="[ !montantSalaireBrutContractuel || !isValidNumber(montantSalaireBrutContractuel) ? 'form-input-error ml-5' : 'form-input-success ml-5']"/>
                      </td>
                      <td class="px-6 py-4 text-center" v-else>{{ montantSalaireBrutContractuel }}</td>                   
                      <td class="px-6 py-4">                      
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>


            </div>
          </div>
        </div>

        <!-- INDEMNITE JOURNALIERE-->
        <div class="flex justify-center space-x-5 mt-5">
          <div class="sm:w-11/12 lg:w-3/4">
            <div class="card">
              <div class="flex flex-row justify-between">
                <h5 class="h5">Estimation de l'indemnité journalière</h5>
              <button v-on:click="computeIndemniteJournaliere" type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Calculer</button>            
              </div>                        
              <div v-show="displayWarning" class="p-4 mb-4 text-sm text-yellow-800 rounded-lg bg-yellow-50 dark:bg-gray-800 dark:text-yellow-300 mt-5" role="alert">
                <span class="font-bold">Indémnité non calculée !</span> Merci de compléter correctement le formulaire
              </div>

              <div class="flex flex-row space-x-5 mt-5">
                <label for="indemnite-normale" class="mt-3 form-label w-1/3">Indemnité journalière normale: </label>
                <input type="text" v-model="montantIndemniteNormale" class="form-input-disabled w-48">
              </div>

              <div class="flex flex-row space-x-5 mt-5">
                <label for="indemnite-majoree" class="mt-3 form-label w-1/3">Indemnité journalière majorée: </label>
                <input type="text" v-model="montantIndemniteMajoree" class="form-input-disabled w-48">
              </div>

              <br>
              <br>
              <b>NB:</b> Nous vous proposons une estimation du montant de votre indemnité journalière, le montant définitif sera établi par le service compétent lors de l'examen de votre dossier, en se basant sur la réglementation en vigueur, <a class="font-medium text-blue-600 dark:text-blue-500 hover:underline" target="_blank" href="https://www.ameli.fr/alpes-maritimes/entreprise/vos-salaries/montants-reference/indemnites-journalieres-montants-maximum">les montants maximums des indemnités journalières</a> et l'historique de celui-ci.
            </div>
          </div>
        </div>

      </div>

    </div>

    <div class="flex-none bg-sky-200">
      <FooterComponent />
    </div>

  </div>

</template>

<script>
import FooterComponent from './components/FooterComponent.vue';
import HeaderComponent from './components/HeaderComponent.vue'
//import HeroComponent from './components/HeroComponent.vue'
import moment from 'moment'
import {mask} from 'vue-the-mask'
import { jsPDF } from "jspdf";

export default {
  name: 'App',
  components: {
    HeaderComponent,
    //HeroComponent,
    FooterComponent,    
  },
  directives: {
    mask
  },
  data() {
    return {
      dateSituationLabels: {
      },
      selectSituation: 'ATMP',
      selectSitutationTexts: {},
      selectSitutationText: 'Accident du travail / Maladie Professionnelle',
      //dateSituationSaisie: '',
      dateSituationSaisie: '',
      dateSituationCalculee: '',
      sDateSituationCalculee: '',
      dateSituationLabel: 'Dernier jour de présence effective  dans l\'entreprise',
      dateInf: null,
      dateSup: null,
      dateInfMonth: '',
      dateSupMonth: '',
      formatter: new Intl.DateTimeFormat('fr', { month: 'long' }),
      salaireBrut: '',
      montantCotisations: '',
      /*primes: [
        { id: 0, dateVersement: '01/04/2024', du: '01/01/2024', au: '31/03/2024', montant: '333', periodicite: 0, dateReportDebut: null, dateReportFin: null, montantPeriodicite: 0, priseEnCompte: null },
        { id: 1, dateVersement: '01/01/2023', du: '01/01/2022', au: '31/12/2022', montant: '1212', periodicite: 0, dateReportDebut: null, dateReportFin: null, montantPeriodicite: 0, priseEnCompte: null },
        { id: 2, dateVersement: '01/01/2024', du: '01/01/2023', au: '31/12/2023', montant: '1212', periodicite: 0, dateReportDebut: null, dateReportFin: null, montantPeriodicite: 0, priseEnCompte: null },
        { id: 3, dateVersement: '01/07/2023', du: '01/01/2023', au: '30/06/2023', montant: '666', periodicite: 0, dateReportDebut: null, dateReportFin: null, montantPeriodicite: 0, priseEnCompte: null }
      ],*/
      //primes: [{ id: 0, dateVersement: '31/12/2022', du: '01/01/2022', au: '31/12/2022', montant: '', periodicite: 0, dateReportDebut: null, dateReportFin: null, montantPeriodicite: 0, priseEnCompte: false }],
      //primes: [{ id: 0, dateVersement: '', du: '', au: '', montant: '', periodicite: 0, dateReportDebut: null, dateReportFin: null, montantPeriodicite: 0, priseEnCompte: false }],
      primes: [],
      montantPerteSalaire: '',      
      montantSalaireBrutContractuel: '',
      montantIndemniteNormale: 0,
      montantIndemniteMajoree: 0,
      radioRetablissementSalaire: 'perteSalaire', 
      displayWarning: false       
    }
  },  
  computed: {
    montantCotisationsCalcule() {
      return ((Number(this.montantSalaireBrutContractuel) - Number(this.salaireBrut)) * 0.21).toFixed(2);
    },    
  },
  methods: {
    hasPrimes() {
      let addPrimes = false;
        for (let i = 0; i < this.primes.length; i++) {
          if (this.primes[i].priseEnCompte) {
            addPrimes = true;
            break;
          }          
        }
      return addPrimes;
    },
    exportToPDF() {      

      var img = ' data:image/png;base64,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';
      
      const doc = new jsPDF();
      
      doc.setTextColor(255,255,255);
      doc.setDrawColor(0);
      doc.setFillColor(3,105,161);
      doc.rect(0, 0, doc.internal.pageSize.getWidth()-0.1, 15, "F");

      doc.setTextColor(255,255,255);
      doc.addImage(img, 3, 2, 6,6);
      doc.setFontSize(8);
      doc.text("L'assurance maladie", 11, 6);
      doc.setFontSize(6);
      doc.text("CPAM des Alpes-Maritimes", 11, 10);
            
      doc.setFontSize(12);      
      doc.text("Données de calcul de l’indemnité journalière AT/MP « SIMUL’IJ SS AT/MP »", 48, 9);

      let yPos = 20;
      doc.setFontSize(10);
      doc.setTextColor(0,0,0);
      yPos = yPos + 20;
      doc.text("Situation du salarié: ", 10, yPos);
      doc.text(this.selectSitutationTexts[this.selectSituation], 120, yPos);
      yPos = yPos + 10;
      doc.text("Premier jour de l'arret de travail       :", 10, yPos);
      doc.text(this.dateSituationSaisie, 120, yPos);
      yPos = yPos + 5;
      doc.text("(à relever sur la prescription médicale)", 10, yPos);            
      yPos = yPos + 10;
      doc.text("Dernier jour de travail à renseigner sur l'attestation de salaire:", 10, yPos);
      doc.text(this.sDateSituationCalculee, 120, yPos);

      yPos = yPos + 10;
      doc.text("La période de référence est à déterminer à partir du dernier jour de travail (DJT) et du risque concerné.", 10, yPos);
      yPos = yPos + 5;
      doc.text("Pour un salarié standard en " + this.selectSitutationText + ", il convient de déclarer les éléments de salaire ", 10, yPos);
      yPos = yPos + 5;
      doc.text("se rapportant au(x) mois de "
      + (this.selectSituation == 'MM' || this.selectSituation == 'P1' || this.selectSituation == 'P2' ? this.dateInfMonth + " à " + this.dateSupMonth : this.dateSupMonth), 10, yPos);
      
      if (this.selectSituation == 'ATMP' || this.selectSituation == 'ATA' || this.selectSituation == 'ATS') {
        yPos = yPos + 10;
        doc.text("Salaire de base brut soumis à cotisations (en €):", 10, yPos);
        doc.text(this.salaireBrut + '€', 120, yPos);
        yPos = yPos + 10;
        doc.text("Montant des cotisations à déclarer (21% du Brut):", 10, yPos);
        doc.text(this.montantCotisations + '€', 120, yPos);
        yPos = yPos + 10;
        doc.text("Salaire de base Brut réellement perçu :", 10, yPos);
        doc.text(this.salaireBrut + '€', 120, yPos);
        yPos = yPos + 10;
        doc.text("Montant de la perte de salaire :", 10, yPos);
        doc.text(this.montantPerteSalaire + '€', 120, yPos);
        yPos = yPos + 10;
        doc.text("Montant du salaire Brut contractuel", 10, yPos);
        yPos = yPos + 5;
        doc.text("(si le salarié a travaillé toute la période)", 10, yPos);      
        doc.text(this.montantSalaireBrutContractuel + '€', 120, yPos-5);
        yPos = yPos + 10;        

        if (this.hasPrimes()>0) {
          doc.text("Primes: ", 10, yPos);       
          yPos = yPos + 5;
          for (let i = 0; i < this.primes.length; i++) {
            if (this.primes[i].priseEnCompte && this.isValidNumber(this.primes[i].montantPeriodicite)) {
              doc.text("Date de versement: ", 10, yPos);
              doc.text(this.primes[i].dateVersement, 42, yPos);
              doc.text("du ", 70, yPos);
              doc.text(this.primes[i].du, 80, yPos);
              doc.text("au ", 102, yPos);
              doc.text(this.primes[i].au, 110, yPos);
              doc.text("Montant périodicité: ", 140, yPos);
              doc.text(this.primes[i].montantPeriodicite + ' €', 175, yPos);
              yPos = yPos + 5;
            }
          }          
          yPos = yPos + 5;
        }
          
        doc.text("Indeminté normale", 10, yPos);
        doc.text(this.montantIndemniteNormale + '€', 120, yPos);
        yPos = yPos + 10;
        doc.text("Indeminté majorée", 10, yPos);
        doc.text(this.montantIndemniteMajoree + '€', 120, yPos);
      }
      
      doc.save("simul_ij_ss_atmp.pdf");
    },
    clearAll() {      
      this.selectSituation= 'ATMP';
      this.selectSitutationText= 'Accident du travail / Maladie Professionnelle';
      this.dateSituationSaisie= '';      
      this.dateSituationCalculee= '';
      this.sDateSituationCalculee= '';
      this.dateSituationLabel= 'Dernier jour de présence effective  dans l\'entreprise';
      this.dateInf= null;
      this.dateSup= null;
      this.dateInfMonth= '';
      this.dateSupMonth= '';
      this.salaireBrut= '';
      this.montantCotisations= '';      
      this.primes= [];
      this.montantPerteSalaire= '';
      this.montantSalaireBrutContractuel= '';
      this.montantIndemniteNormale= 0;
      this.montantIndemniteMajoree= 0;
      this.radioRetablissementSalaire= 'perteSalaire';
      this.displayWarning= false;
    },
    computeDateSituationCalculee() {      
      if (this.isValidDate(this.dateSituationSaisie)) {
        let parts = this.dateSituationSaisie.split('/');
        this.dateSituationCalculee = new Date(parts[2] + '-' + parts[1] + '-' + parts[0]);        
        if (this.selectSituation == 'MM' || this.selectSituation == 'P2') {
          this.dateSituationCalculee.setDate(this.dateSituationCalculee.getDate() - 1);
        }
        parts = this.dateSituationCalculee.toISOString().slice(0, 10).split('-');
        this.sDateSituationCalculee = parts[2] + '/' + parts[1] + '/' + parts[0];
      }
    },

    compareDates(d1, d2) {
      let date1 = new Date(d1).getTime();
      let date2 = new Date(d2).getTime();

      if (date1 < date2) {
        return -1;
      } else if (date1 > date2) {
        return 1;
      } else {
        return 0;
      }
    },
    monthDiff(dateFrom, dateTo) {
      return dateTo.getMonth() - dateFrom.getMonth() + (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    },
    computeIndemniteJournaliere() {

      this.updatePrimes();

      if (this.isValidDate(this.dateSituationSaisie)
        && this.isValidNumber(this.salaireBrut)
        && this.isValidNumber(this.montantSalaireBrutContractuel)
      ) {        
        let indemniteNormale = Number(this.salaireBrut);
        indemniteNormale = Number(indemniteNormale) + Number(this.montantPerteSalaire);  
        
        if (this.selectSituation == 'ATMP' || this.selectSituation == 'ATA' || this.selectSituation == 'ATS') {
          for (let i = 0; i < this.primes.length; i++) {
            if (this.primes[i].priseEnCompte && this.isValidNumber(this.primes[i].montantPeriodicite)) {
              indemniteNormale = Number(Number(indemniteNormale) + Number(this.primes[i].montantPeriodicite));
            }
          }
        }
        
        this.montantIndemniteNormale = Number(indemniteNormale/30.42*0.6).toFixed(2);      
        this.montantIndemniteMajoree = Number(indemniteNormale/30.42*0.79).toFixed(2);

        this.displayWarning = false;
      } else {
        this.displayWarning = true;
      }
      
    },
    deletePrime(id) {      
      for (let i = 0; i < this.primes.length; i++) {
        if (id == this.primes[i].id) {
          this.primes.splice(i, 1);                    
          break;
        }
      }      
    },
    addPrime() {
      let maxId = 0;      
      for (let i = 0; i < this.primes.length; i++) {
        if (maxId<this.primes[i].id) {
          maxId = this.primes[i].id;
        }
      }
      this.primes.push({ id: this.primes.length == 0 ? 0 : maxId + 1, dateVersement: '', du: '', au: '', 
        montant: 0, periodicite: 0, dateReportDebut: null, dateReportFin: null, montantPeriodicite: 0, priseEnCompte: null })
    },
    addMonths(date, months) {
      date.setMonth(date.getMonth() + months);
      return date;
    },
    isLastDayOfMonth(date) {
      var lastDayOfMonthDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return date.getDate() == lastDayOfMonthDate.getDate();
    },
    isValidDate(s) {
      return moment(s, "DD/MM/YYYY", true).isValid();        
    },    
    computeDateSituationCalculeeLabel() {
      if (this.isValidDate(this.dateSituationCalculee)) {
        let isLastDayOfMonth = this.isLastDayOfMonth(this.dateSituationCalculee);
        this.dateSup = new Date(this.dateSituationCalculee);

        if (!isLastDayOfMonth) {
          this.dateSup.setMonth(this.dateSup.getMonth() - 1);
        }
        this.dateSup = new Date(this.dateSup.getFullYear(), this.dateSup.getMonth() + 1, 0);
        this.dateSup.setDate(this.dateSup.getDate()-1);

        let dateSupFirstDayOfMonth = new Date(this.dateSup.getFullYear(), this.dateSup.getMonth() + 1, 1);
        this.dateInf = new Date(dateSupFirstDayOfMonth);
        this.dateInf.setMonth(dateSupFirstDayOfMonth.getMonth() - 3);

        this.dateInfMonth = this.formatter.format(this.dateInf) + ' ' + this.dateInf.getFullYear();
        this.dateSupMonth = this.formatter.format(this.dateSup) + ' ' + this.dateSup.getFullYear();
      }      
    },
    computeSelectSituationLabel() {      
      this.dateSituationLabel = this.dateSituationLabels[this.selectSituation];
      this.selectSitutationText = this.selectSitutationTexts[this.selectSituation];
    },
    isValidNumber(s) {
      let regexp = /^[+-]?\d+(\.\d+)?$/;
      return regexp.test(s);
    },
    computeMontantCotisations() {
      if (this.isValidNumber(this.salaireBrut)) {
        this.montantCotisations = (this.salaireBrut * 0.21).toFixed(2);        
      }
    },
    computeMontantSalaireBrutContractuel() {
      if (this.radioRetablissementSalaire=='perteSalaire' && this.isValidNumber(this.montantPerteSalaire)) {
        this.montantSalaireBrutContractuel = (Number(this.salaireBrut) + Number(this.montantPerteSalaire)).toFixed(2);
      }
    },
    computePerteSalaire() {
      if (this.radioRetablissementSalaire=='salaireBrutContractuel') {
        this.montantPerteSalaire = (Number(this.montantSalaireBrutContractuel) - Number(this.salaireBrut)).toFixed(2);
      }
    },
    refreshAll() {
      this.computeSelectSituationLabel();
      this.computeDateSituationCalculee();
      this.computeDateSituationCalculeeLabel();
      this.computeMontantCotisations();
      this.computeMontantSalaireBrutContractuel();
      this.computePerteSalaire();
      this.updatePrimes();
    },
    updatePrimes() {
      
      if ((this.selectSituation == 'ATMP' || this.selectSituation == 'ATA' || this.selectSituation == 'ATS')
        && this.isValidDate(this.dateSup)) {
        
        for (let i = 0; i < this.primes.length; i++) {

          if (this.isValidDate(this.primes[i].dateVersement)
            && this.isValidDate(this.primes[i].du)
            && this.isValidDate(this.primes[i].au)
          ) {
            let parts = this.primes[i].du.split('/');        
            let dateReportInf = new Date(parts[2] + '-' + parts[1] + '-' + parts[0]);
            parts = this.primes[i].au.split('/');
            let dateReporSup = new Date(parts[2] + '-' + parts[1] + '-' + parts[0]);
            parts = this.primes[i].dateVersement.split('/');
            let dateVersement = new Date(parts[2] + '-' + parts[1] + '-' + parts[0]);

            let periodicite = this.monthDiff(dateReportInf, dateReporSup) + 1;
            this.primes[i].periodicite = periodicite;
            
            this.primes[i].dateReportDebut = new Date(dateVersement);
            if (this.compareDates(dateVersement, dateReportInf)>=0
              && this.compareDates(dateVersement, dateReporSup)<=0
            ) {          
              this.primes[i].dateReportDebut.setDate(1);
            } else {
              this.primes[i].dateReportDebut.setDate(1);
              this.primes[i].dateReportDebut.setMonth(this.primes[i].dateReportDebut.getMonth()+1);              
            }
            this.primes[i].dateReportFin = new Date(this.primes[i].dateReportDebut);
            this.primes[i].dateReportFin.setMonth(this.primes[i].dateReportFin.getMonth()+this.primes[i].periodicite-1);
            this.primes[i].dateReportFin = new Date(this.primes[i].dateReportFin.getFullYear(), this.primes[i].dateReportFin.getMonth()+1, 0);
            this.primes[i].montantPeriodicite = (this.primes[i].montant / this.primes[i].periodicite).toFixed(2);            

            this.primes[i].priseEnCompte = this.compareDates(this.dateSup, this.primes[i].dateReportDebut) >=0
              && this.compareDates(this.dateSup, this.primes[i].dateReportFin ) <=0;          
          }

        }
      }
    }

  },
  created() {
    this.dateSituationLabels['MM'] = 'Premier jour de l\'arret de travail (à relever sur la prescription médicale)';
    this.dateSituationLabels['P1'] = 'Dernier jour de congé paternité payé par l\'employeur';
    this.dateSituationLabels['P2'] = 'Premier jour de l\'arret de travail (à relever sur la prescription médicale)';
    this.dateSituationLabels['ATMP'] = 'Dernier jour de présence effective  dans l\'entreprise';
    this.dateSituationLabels['ATA'] = 'Date de l\'accident de trajet en allant travailler';
    this.dateSituationLabels['ATS'] = 'Dernier jour de présence effective  dans l\'entreprise';

    this.selectSitutationTexts['MM'] = 'Maladie - Maternité';
    this.selectSitutationTexts['P1'] = 'Paternité - 1ère interruption de travail';
    this.selectSitutationTexts['P2'] = 'Paternité - 2nd interruption de travail et suivantes';
    this.selectSitutationTexts['ATMP'] = 'Accident du travail / Maladie Professionnelle';
    this.selectSitutationTexts['ATA'] = 'Accident de trajet - en allant travailler';
    this.selectSitutationTexts['ATS'] = 'Accident de trajet - en sortant du travail';
  },
  watch: {
    selectSituation() {
      this.refreshAll();
    },
    dateSituationSaisie() {      
      this.refreshAll();      
    },
    sDateSituationCalculee() {
      this.refreshAll();
    },
    salaireBrut() {
      this.refreshAll();
    },
    montantPerteSalaire() {
      this.refreshAll();      
    },
    montantSalaireBrutContractuel() {
      this.refreshAll();
    },    
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  /*margin-top: 60px;*/
}
</style>
